import { useId } from 'react';

interface LogoProps {
  size?: number;
  className?: string;
}

export function Logo({ size = 36, className }: LogoProps) {
  const id = useId();
  const gradientId = `logo-grad-${id}`;
  const maskId = `logo-mask-${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width={size}
      height={size}
      role="img"
      aria-label="Converlang logo"
      className={className}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#6366F1" />
          <stop offset="1" stopColor="#06B6D4" />
        </linearGradient>
        <mask id={maskId}>
          <rect x="0" y="0" width="256" height="256" fill="#FFFFFF" />
          <g fill="#000000">
            <rect x="81" y="126" width="16" height="24" rx="8" />
            <rect x="107" y="114" width="16" height="36" rx="8" />
            <rect x="133" y="102" width="16" height="48" rx="8" />
            <rect x="159" y="90" width="16" height="60" rx="8" />
          </g>
        </mask>
      </defs>
      <rect x="18" y="18" width="220" height="220" rx="56" fill={`url(#${gradientId})`} />
      <path
        fill="#FFFFFF"
        mask={`url(#${maskId})`}
        d="M78 62 H178 C192.4 62 204 73.6 204 88 V138 C204 152.4 192.4 164 178 164 H108 L94 186 L78 164 C63.6 164 52 152.4 52 138 V88 C52 73.6 63.6 62 78 62 Z"
      />
    </svg>
  );
}
